import { CategoryDocument } from 'models/category';
import Image from 'next/image';
import { SetStateAction } from 'react';
import { useCreateListing } from '../_context';

type Props = {
  setEditCategoryModalOpen: (value: SetStateAction<boolean>) => void
}

const getLastImage = (categoryInfo: CategoryDocument[]) => {
  for (let i = categoryInfo.length - 1; i >= 0; i--) {
    const item = categoryInfo[i];

    if (item?.image) {
      return item.image;
    }

    if (item?.header_image) {
      return item.header_image;
    }
  }

  return null;
}

export const CategorySummary = ({ setEditCategoryModalOpen }: Props) => {
  const { categoryInfo } = useCreateListing();
  const categoriesDisplay = categoryInfo.map((c) => c.name).join(' > ');
  const categoryImage = getLastImage(categoryInfo || []);

  return (
    <div className="flex h-64 w-full items-start justify-between overflow-hidden sm:rounded-3xl sm:border border-zinc-200 bg-white">
      <div className="relative">
        <Image
          src={categoryImage || ''}
          alt="category photo"
          width={180}
          height={120}
          className="size-64"
          priority
        />
        <div
          className="absolute inset-0 h-64 w-full bg-gradient-to-r from-transparent via-transparent via-[50%] to-white md:h-64"
          aria-hidden
        />
      </div>
      <div className="flex h-full flex-1 justify-between p-8 flex-row md:p-12">
        <div className="flex flex-col gap-2 self-center">
          <span className="text-body-lg font-semibold text-black">
            Sports & Categories
          </span>
          <span className="text-body-md font-medium text-text-muted">
            {categoriesDisplay}
          </span>
        </div>

        <button
          className="cursor-pointer text-body-md font-semibold text-brand-secondary h-fit"
          onClick={() => {
            setEditCategoryModalOpen(true);
          }}
          type="button"
        >
          Edit
        </button>
      </div>
    </div>
  )
}
